import { useState } from "react";
import { apiFetch, ApiClientError } from "../../lib/apiClient";

const DEFAULT_NOTICE =
  "質問内容およびウェビナー上の行動データが、ウェビナー運営・フォローアップ・HubSpot上での顧客管理に利用されることに同意します。";

// 視聴ページ入場時に一度だけ同意を取るゲート。同意すると質問フォームが有効になる。
export function ConsentGate({
  rid,
  notice,
  onConsented,
}: {
  rid: string;
  notice: string | null;
  onConsented: () => void;
}) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function agree() {
    setBusy(true);
    setError(null);
    try {
      await apiFetch("/api/public/registrations/consent", {
        method: "POST",
        body: JSON.stringify({ registration_token: rid }),
      });
      onConsented();
    } catch (err) {
      setError(
        err instanceof ApiClientError ? err.message : "同意の記録に失敗しました",
      );
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="consent-gate">
      <h2>ご視聴の前に</h2>
      <p className="consent-notice">{notice ?? DEFAULT_NOTICE}</p>
      {error && (
        <p className="form-error" role="alert">
          {error}
        </p>
      )}
      <button type="button" className="btn-primary" disabled={busy} onClick={agree}>
        {busy ? "処理中..." : "同意して質問を始める"}
      </button>
    </div>
  );
}
